import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class IpAddressService {

  constructor(private http: HttpClient) {

   }

   getIpFromIpify()  {

    return this.http.get(`${environment.exiBackendUrl}/api/getip` )

    //return this.http.get("https://ipapi.co/json")
    //https://ipapi.co/json
    // return this.http.get("https://api.ipify.org/?format=json")
   }

  //  getIpFromIpConfig() {
  //   return this.http.get("https://ifconfig.me/ip")
  //  }
   

}